import React from "react";
import { PropertyCardListView } from "./PropertyCardListView";
import {
  PropertyCardGridView,
  PropertyDataInterface,
} from "./PropertyCardGridView";

interface PropertyListCardContainerProps {
  property: PropertyDataInterface;
  viewMode: "grid" | "list";
  onCardClick?: (property: PropertyDataInterface) => void;
  onRequestImagesClick?: (property: PropertyDataInterface) => void;
}

export const PropertyListCardContainer: React.FC<
  PropertyListCardContainerProps
> = ({
  property,
  onCardClick = () => {},
  onRequestImagesClick = () => {},
  viewMode = "grid",
}) => {
  const View =
    viewMode === "list" ? PropertyCardListView : PropertyCardGridView;

  return (
    <View
      property={property}
      onCardClick={onCardClick}
      onRequestImagesClick={onRequestImagesClick}
    />
  );
};
